// ABOUTME: Switches the tab's active market and reloads, so every query is refetched in the new market.
// ABOUTME: The market is stored before the navigation so the reloaded tab boots in it.

import { setActiveMarket } from '../activeMarketStore';

type Navigate = (url: string) => void;

const defaultNavigate: Navigate = url => window.location.assign(url);

/**
 * Stores `marketId` for this tab, then navigates to `then` (default: the current page) with a
 * full reload.
 */
export const switchActiveMarket = (
    marketId: string,
    then?: string,
    navigate: Navigate = defaultNavigate,
) => {
    setActiveMarket(marketId);
    navigate(then ?? window.location.href);
};
